import { cn } from "@/lib/utils";
import * as Icons from "lucide-react";

export function StatCard({ label, value, icon, accent = "primary", hint, testid, delay = 0 }) {
  const Icon = (icon && Icons[icon]) || Icons.Activity;
  const accents = {
    primary: "text-primary bg-primary/10",
    blue: "text-forest-600 bg-sage/15",
    green: "text-emerald-600 bg-emerald-50",
    amber: "text-amber-600 bg-amber-50",
    red: "text-red-600 bg-red-50",
  };
  return (
    <div
      data-testid={testid}
      className="animate-fade-in-up rounded-lg border border-slate-200 bg-white p-5 shadow-sm transition-all duration-200 hover:shadow-md hover:-translate-y-0.5"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
          <p className="mt-2 font-heading text-2xl font-semibold text-slate-900 tabular-nums truncate">{value}</p>
          {hint && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
        </div>
        <div className={cn("flex h-10 w-10 shrink-0 items-center justify-center rounded-lg", accents[accent])}>
          <Icon className="h-5 w-5" strokeWidth={1.75} />
        </div>
      </div>
    </div>
  );
}
